module.exports = __webpack_public_path__ + "static/territorio1_r-7f6c8f8e92ef04a69a63f4577fcfb797.png";